<template>
  <div class="member-level-rules">
    <el-card shadow="hover">
      <template slot="header">
        <div class="card-header">
          <span>等级规则配置</span>
          <div class="right-actions">
            <el-button type="primary" size="small" class="btn-primary" @click="showAddDialog">
              新增等级
            </el-button>
          </div>
        </div>
      </template>

      <el-alert
        type="info"
        :closable="false"
        show-icon
        style="margin-bottom: 16px;"
        title="保级与降级说明"
        description="升级仍按「当月累计消费」达标。等级跨月保留；自最近一次消费起连续 3 个月未消费，自动降一级，更久则每满 3 个月再降一级，最低降至起始等级。"
      />
      <el-table
        :data="rules"
        style="width: 100%"
        border
        header-align="center"
        align="center"
      >
        <el-table-column prop="level_code" label="等级" min-width="100" />
        <el-table-column prop="level_name" label="等级名称" min-width="180" />
        <el-table-column prop="min_month_amount" label="升级门槛(当月累计消费)" min-width="220" />
        <el-table-column prop="gift_points" label="升级赠送积分" min-width="140" />
        <el-table-column prop="gift_coupon_count" label="升级赠送券权益数" min-width="180" />
        <el-table-column prop="benefits_text" label="核心权益" min-width="260">
          <template slot-scope="scope">
            <span>{{ scope.row.benefits_text }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="sort_order" label="排序" min-width="90" />
        <el-table-column label="操作" width="260">
          <template slot-scope="scope">
            <el-button size="small" class="btn-secondary" @click="editRule(scope.row)">
              编辑
            </el-button>
            <el-button size="small" class="btn-secondary danger" @click="deleteRule(scope.row.id)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div v-if="!rules.length" style="padding: 16px; color: #909399;">
        当前没有等级规则（接口接入后会自动显示）
      </div>
    </el-card>

    <!-- 新增/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="650px">
      <el-form :model="ruleForm" label-width="140px">
        <el-form-item label="等级编码">
          <el-input v-model="ruleForm.level_code" placeholder="选填，如 S2；留空则保存时自动生成" />
        </el-form-item>
        <el-form-item label="等级名称" required>
          <el-input v-model="ruleForm.level_name" placeholder="必填，例如：人气茗星" />
        </el-form-item>
        <el-form-item label="升级门槛(当月累计消费)">
          <el-input v-model="ruleForm.min_month_amount" type="number" />
        </el-form-item>
        <el-form-item label="升级赠送积分">
          <el-input v-model="ruleForm.gift_points" type="number" />
        </el-form-item>
        <el-form-item label="升级赠送券权益数">
          <el-input v-model="ruleForm.gift_coupon_count" type="number" />
        </el-form-item>
        <el-form-item label="核心权益内容">
          <el-input
            v-model="ruleForm.benefits_text"
            type="textarea"
            :rows="4"
            placeholder="例如：单杯7.5折、第2杯5折、每月礼包"
          />
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model="ruleForm.sort_order" type="number" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveRule">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'MemberLevelRules',
  data() {
    return {
      rules: [],
      dialogVisible: false,
      dialogTitle: '新增等级',
      ruleForm: {
        id: null,
        level_code: '',
        level_name: '',
        min_month_amount: 0,
        gift_points: 0,
        gift_coupon_count: 0,
        benefits_text: '',
        sort_order: 0
      }
    }
  },
  mounted() {
    this.loadRules()
  },
  methods: {
    async loadRules() {
      try {
        const resp = await this.$api.get('/admin/level-rules')
        if (resp && resp.code === 200) {
          this.rules = resp.data || []
        }
      } catch (e) {
        const msg =
          (e && e.response && e.response.data && e.response.data.message) ||
          (e && e._networkHint) ||
          '获取等级规则失败'
        this.$message.error(msg)
      }
    },
    showAddDialog() {
      this.dialogTitle = '新增等级'
      this.dialogVisible = true
      this.ruleForm = {
        id: null,
        level_code: '',
        level_name: '',
        min_month_amount: 0,
        gift_points: 0,
        gift_coupon_count: 0,
        benefits_text: '',
        sort_order: 0
      }
    },
    editRule(row) {
      this.dialogTitle = '编辑等级'
      this.dialogVisible = true
      this.ruleForm = {
        id: row.id,
        level_code: row.level_code,
        level_name: row.level_name,
        min_month_amount: row.min_month_amount,
        gift_points: row.gift_points,
        gift_coupon_count: row.gift_coupon_count,
        benefits_text: row.benefits_text,
        sort_order: row.sort_order
      }
    },
    async saveRule() {
      if (!String(this.ruleForm.level_name || '').trim()) {
        this.$message.warning('请填写等级名称')
        return
      }
      try {
        const payload = { ...this.ruleForm }
        const resp = await this.$api.post('/admin/level-rules', payload)
        if (resp && resp.code === 200) {
          this.$message.success('保存成功')
          this.dialogVisible = false
          await this.loadRules()
        } else {
          this.$message.error((resp && resp.message) || '保存失败')
        }
      } catch (e) {
        const msg =
          (e && e.response && e.response.data && e.response.data.message) ||
          (e && e._networkHint) ||
          '保存失败'
        this.$message.error(msg)
      }
    },
    deleteRule(id) {
      this.$confirm('确定要删除该等级规则吗？', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const resp = await this.$api.delete(`/admin/level-rules/${id}`)
          if (resp && resp.code === 200) {
            this.$message.success('删除成功')
            await this.loadRules()
          } else {
            this.$message.error((resp && resp.message) || '删除失败')
          }
        } catch (e) {
          const msg =
            (e && e.response && e.response.data && e.response.data.message) ||
            '删除失败'
          this.$message.error(msg)
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.member-level-rules :deep(.el-card__body) {
  padding: 18px;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.right-actions {
  display: flex;
  gap: 10px;
}
</style>

